import React from "react";
import { useTranslation } from "react-i18next";
import { FiLock } from "react-icons/fi";
import { MAIN_URL } from "../../utils/appHost";

// Every expiry any plan offers, in display order (days, 0 = never)
export const ALL_EXPIRY_OPTIONS = [1, 3, 7, 30, 0];

/** Expiry chips. Options outside the user's plan are shown locked with an upgrade link. */
export default function ExpirySelect({ value, onChange, allowed = [1] }) {
  const { t } = useTranslation();
  const hasLocked = ALL_EXPIRY_OPTIONS.some((d) => !allowed.includes(d));

  return (
    <div>
      <div className="shr-chips" role="radiogroup">
        {ALL_EXPIRY_OPTIONS.map((days) => {
          const locked = !allowed.includes(days);
          return (
            <button
              key={days}
              type="button"
              role="radio"
              aria-checked={value === days}
              disabled={locked}
              className={`shr-chip${value === days ? " active" : ""}${locked ? " locked" : ""}`}
              onClick={() => onChange(days)}
              title={locked ? t("share.expiry.locked") : undefined}
            >
              {locked && <FiLock size={12} />}
              {t(`share.expiry.d${days}`)}
            </button>
          );
        })}
      </div>
      {hasLocked && (
        <a className="shr-upgrade-link" href={`${MAIN_URL}/plans`}>
          {t("share.expiry.upgrade")}
        </a>
      )}
    </div>
  );
}
